import http from "plugins/axios";

export default {
  getList(data) {
    return http.post({
      url: "/ta/admin/user/riskPanel/list",
      data,
    });
  },
};

